import { useContext } from "react";
import { langContext, termsUrl } from "../api/Lang";

const el = {
    title: "Πολιτική Cookies",
    descriptionIntro:
        "Χρησιμοποιούμε cookies για να βελτιώσουμε την εμπειρία σας στην ιστοσελίδα μας. Τα cookies μας βοηθούν να:",
    bulletPreferences: "Να θυμόμαστε τις προτιμήσεις σας (π.χ. γλώσσα)",
    bulletLoggedIn: "Να διατηρούμε την σύνδεσή σας",
    bulletAnalytics: "Να αναλύουμε τη χρήση της ιστοσελίδας για βελτιώσεις",
    bulletServices: "Να παρέχουμε καλύτερες υπηρεσίες",
    policyPrefix: "Συνεχίζοντας, συμφωνείτε με τη χρήση cookies σύμφωνα με την",
    policyLink: "Πολιτική Cookies",
    decline: "Απόρριψη",
    accept: "Αποδοχή",
};

const en: typeof el = {
    title: "Cookies Policy",
    descriptionIntro:
        "We use cookies to improve your experience on our website. Cookies help us to:",
    bulletPreferences: "Remember your preferences (e.g. language)",
    bulletLoggedIn: "Keep you logged in",
    bulletAnalytics: "Analyze website usage for improvements",
    bulletServices: "Provide better services",
    policyPrefix: "By continuing, you agree to the use of cookies in accordance with our",
    policyLink: "Cookies Policy",
    decline: "Decline",
    accept: "Accept",
};

const cookiesConsentLangs = { el, en };

export function useCookiesConsentStrings() {
    const [lang] = useContext(langContext);
    const s = cookiesConsentLangs[lang];
    return {
        ...s,
        cookiesPolicyUrl: termsUrl("cookies", lang),
    };
}
